import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#top", label: "首页", icon: "ri-home-5-line" },
  { href: "#gubang", label: "今日瓜榜", icon: "ri-bar-chart-2-line" },
  { href: "#guatian", label: "瓜田速递", icon: "ri-flashlight-line" },
  { href: "#gensui", label: "蹲后续", icon: "ri-refresh-line" },
  { href: "#shenping", label: "神评墙", icon: "ri-quote-text" },
  { href: "#guide", label: "吃瓜指南", icon: "ri-question-line" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3">
        <a href="#top" className="group flex items-center gap-2 whitespace-nowrap">
          <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-eye-2-line text-xl"></i>
          </span>
          <span className="heading-font text-xl text-primary-600 group-hover:text-primary-700">每日看瓜</span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200 hover:text-primary-600"
            >
              <i className={`${l.icon} text-base`}></i>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-notification-3-line"></i>
            追更订阅
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className="grid h-10 w-10 cursor-pointer place-items-center rounded-md bg-background-200 text-foreground-800 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden animate-pop" aria-label="移动端导航">
          <div className="grid gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-200"
              >
                <i className={`${l.icon} text-primary-500`}></i>
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-3 py-2.5 text-sm text-background-50 hover:bg-primary-600"
            >
              <i className="ri-notification-3-line"></i>
              追更订阅
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}